import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from 'utils/axios';

export const fetchAdditionalsOrder = createAsyncThunk(
  'additionals/fetchAdditionalsOrder',
  async (transaction_key, thunkAPI) => {
    try {
      const res = await axiosInstance.get(`/admin/orders/${transaction_key}/additional-fees`);

      return res.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  },
);

export const addAdditionalOrder = createAsyncThunk('additionals/addAdditionalOrder', async (payload, thunkAPI) => {
  try {
    const res = await axiosInstance.post(`/additional-fees`, { ...payload });

    return res.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const deleteAdditionalOrderById = createAsyncThunk(
  'additionals/deleteAdditionalOrderById',
  async (id, thunkAPI) => {
    try {
      const res = await axiosInstance.delete(`/additional-fees/${id}`);

      return res.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  },
);
